import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import RouteCalls from "../../RouteCalls";
import { useFormContext } from "react-hook-form";
import BusyNoAnswerRoute from "../editUtils/BusyNoAnswerRoute";

const HGRoutings = ({
  routDetails,
  assocCallFlows,
  hgcode,
  executeSetting,
  setIsloading,

  // didSearchError,
  // setdidSearchError,
  // innerDidSearchError,
  // setinnerDidSearchError,
}) => {
  const { t, i18n } = useTranslation();
  const [ringDis, setRingDis] = useState({});
  const [destRecords, setDestRecords] = useState({});
  const [displayOver, setDisplayOver] = useState(true);
  const [displaySeq, setDisplaySeq] = useState(true);
  const [updateDest, setUpdateDest] = useState({});
  const [isUpdateDest, setIsUpdateDest] = useState(false);
  const [callerList, setCallerList] = useState([]);
  const [ringDestVal, setringDestVal] = useState(0);
  const [routeDetails, setRouteDetails] = useState({});
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    setError,
    clearErrors,
  } = useFormContext();

  useEffect(() => {
    if (isUpdateDest && updateDest) {
      console.log(
        "callerid Flag :::::::" +
          getValues("routing.busy_or_no_answer.cid_pass_flag")
      );
      console.log("callerid Flag after set:::::::" + updateDest.calleridFlag);

      // setValue("routing.busy_or_no_answer", updateDest, { shouldDirty: true });
      if (updateDest && updateDest.value !== undefined) {
        setValue("routing.busy_or_no_answer.value", updateDest.value, {
          shouldDirty: true,
        });
      }
      if (updateDest && updateDest.destination_type !== undefined) {
        setValue(
          "routing.busy_or_no_answer.destination_type",
          parseInt(updateDest.destination_type),
          { shouldDirty: true }
        );
      }
      if (updateDest && updateDest.entity_type !== undefined) {
        setValue(
          "routing.busy_or_no_answer.entity_type",
          parseInt(updateDest.entity_type),
          { shouldDirty: true }
        );
      }
      if (updateDest && updateDest.timeOutFlag !== undefined) {
        setValue(
          "routing.busy_or_no_answer.timeout_flag",
          updateDest.timeOutFlag,
          { shouldDirty: true }
        );
      }

      if (updateDest && updateDest.timeout !== undefined) {
        setValue(
          "routing.busy_or_no_answer.timeout",
          parseInt(updateDest.timeout),
          {
            shouldDirty: true,
          }
        );
      }

      if (updateDest && updateDest.timeout_routing !== undefined) {
        setValue(
          "routing.busy_or_no_answer.timeout_routing",
          updateDest.timeout_routing,
          { shouldDirty: true }
        );
      }

      if (updateDest && updateDest.timeout_dest_type !== undefined) {
        setValue(
          "routing.busy_or_no_answer.timeout_dest_type",
          updateDest.timeout_dest_type,
          { shouldDirty: true }
        );
      }

      // if (updateDest && updateDest.timeout_entity_type !== undefined) {
      //   setValue(
      //     "routing.busy_or_no_answer.timeout_entity_type",
      //     updateDest.timeout_entity_type,
      //     { shouldDirty: true }
      //   );
      // }

      if (updateDest && updateDest.calleridFlag !== undefined) {
        setValue(
          "routing.busy_or_no_answer.cid_pass_flag",
          updateDest.calleridFlag,
          { shouldDirty: true }
        );
      }

      if (updateDest && updateDest.callerid !== undefined) {
        setValue("routing.busy_or_no_answer.cid_pass", updateDest.callerid, {
          shouldDirty: true,
        });
      }
      setUpdateDest({});
      setIsUpdateDest(false);
    }
  }, [updateDest, isUpdateDest]);

  async function fetchRoutingMiscData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["hunt_routing"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    const ringDisk = tdata?.misc?.hunt_routing?.ring_dist ?? {};
    setringDestVal(getValues("routing.ring_dist"));
    console.log(
      "mergeWithSortList :::::: " +
        JSON.stringify(tdata?.misc?.hunt_routing?.busy_or_no_answer)
    );
    const userList = tdata?.misc?.hunt_routing?.busy_or_no_answer?.user ?? [];
    let groupList = tdata?.misc?.hunt_routing?.busy_or_no_answer?.group ?? [];
    let filteredGroups = groupList.filter(
      (group) => group.code && parseInt(group.code) !== parseInt(hgcode)
    )?.filter((group) => group.category !== "ACD");

    // const hggroupList = filteredGroups.filter(
    //   (group) => group.category !== "Auto-Attendant"
    // );
    // const aagroupList = filteredGroups.filter(
    //   (group) => group.category === "Auto-Attendant"
    // );
    filteredGroups = filteredGroups.sort((a, b) =>
      a?.title?.localeCompare(b?.title)
    );
    const voicemailList =
      tdata?.misc?.hunt_routing?.busy_or_no_answer?.voicemail ?? {};
    const userVoicemailList =
      tdata?.misc?.hunt_routing?.busy_or_no_answer?.user_voicemails ?? [];

    let groupVoicemailList =
      (tdata?.misc?.hunt_routing?.busy_or_no_answer?.group_voicemails ?? [])?.filter((group) => group.category !== "ACD Group-Voicemail");

    setCallerList(tdata?.misc?.hunt_routing?.cid_pass ?? []);
    // groupVoicemailList = groupVoicemailList.filter(
    //   (list) => list.category !== "Auto-Attendant-Voicemail"
    // );

    const voicemails = [...userVoicemailList, ...groupVoicemailList]
      ?.sort((a, b) => a?.title?.localeCompare(b?.title))
      ?.map((item) => ({
        ...item,
        category: item.category.replace(/-Voicemail$/, ""),
      }));

    const listObj = {
      user: userList,
      hggroup: filteredGroups,
      // aagroup: aagroupList,
      voicemail: voicemailList,
      userVoicemail: voicemails,
      // groupVoicemail: groupVoicemailList,
    };

    // const mergeWithSortList = [
    //   ...userList,
    //   ...groupList,
    //   ...userVoicemailList,
    //   ...groupVoicemailList,
    //   voicemailList,
    // ].sort((a, b) => a?.title?.localeCompare(b?.title));
    setRingDis(ringDisk);
    // console.log("mergeWithSortList :::::: "+JSON.stringify(mergeWithSortList));

    setDestRecords(listObj);
  }

  // useEffect(() => {
  //   if (Object.keys(routDetails).length > 0) {
  //     const callerid =
  //       getValues("routing.busy_or_no_answer.cid_pass") != undefined
  //         ? getValues("routing.busy_or_no_answer.cid_pass")
  //         : -1;
  //     const cidpassflag =
  //       getValues("routing.busy_or_no_answer.cid_pass_flag") != undefined
  //         ? getValues("routing.busy_or_no_answer.cid_pass_flag")
  //         : true;
  //     const timeout =
  //       getValues("routing.busy_or_no_answer.timeout") != undefined
  //         ? parseInt(getValues("routing.busy_or_no_answer.timeout"))
  //         : 0;

  //     const TimeFalg =
  //       getValues("routing.busy_or_no_answer.timeout_flag") != undefined
  //         ? getValues("routing.busy_or_no_answer.timeout_flag")
  //         : false;

  //     const routingDetails = {
  //       routeValue: routDetails?.routeValue ?? "",
  //       innerRouteValue: routDetails?.innerRouteValue ?? "",
  //       timeOutFlag: TimeFalg,
  //       timeOut: timeout,
  //       cidPassThrough: cidpassflag,
  //       cidPass: callerid,
  //       showTimeField:
  //         routDetails?.destinationType != undefined
  //           ? parseInt(routDetails.destinationType) === 4
  //             ? true
  //             : false
  //           : false,
  //     };
  //     setRouteDetails(routingDetails);
  //   }
  // }, [routDetails]);

  useEffect(() => {
    if (getValues("routing.ring_dist")) {
      showHideSettings(parseInt(getValues("routing.ring_dist")));
    }
  }, [getValues("routing.ring_dist")]);

  async function showHideSettings(value) {
    //debugger;
    switch (value) {
      case 1:
        setDisplaySeq(false);
        setDisplayOver(true);
        break;
      case 2:
        setDisplayOver(false);
        setDisplaySeq(true);
        break;
      case 3:
        setDisplayOver(false);
        setDisplaySeq(false);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (hgcode !== "") {
      fetchRoutingMiscData();
    }
  }, [hgcode]);

  // Field-name map for the new RouteCalls (HG busy/no-answer)
  const hgBusyFieldNames = {
    destinationType: "routing.busy_or_no_answer.destination_type",
    destinationvalue: "routing.busy_or_no_answer.value",
    entityType: "routing.busy_or_no_answer.entity_type",
    ph_num: "routing.busy_or_no_answer.phnumber",
    timeout: "routing.busy_or_no_answer.timeout",
    timeoutFlag: "routing.busy_or_no_answer.timeout_flag",
    timeoutrouting: "routing.busy_or_no_answer.timeout_routing",
    timeoutdesttyperouting: "routing.busy_or_no_answer.timeout_dest_type",
    cidPassFlag: "routing.busy_or_no_answer.cid_pass_flag",
    cidPass: "routing.busy_or_no_answer.cid_pass",
  };

  return (
    <>
      <div className="general-settings">{t("routing")}</div>
      <div className="margin-top">
        <div className="add-numbermain">
          <div className="tel-numbers">{t("ring_distribution")}</div>
          <div className="phoneselect w-30">
            <select
              className="form-control form-select selectname"
              {...register("routing.ring_dist", {
                setValueAs: (value) => Number(value),
              })}
              value={watch("routing.ring_dist")}
              onChange={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setValue("routing.ring_dist", parseInt(e.target.value), {
                  shouldDirty: true,
                });

                showHideSettings(parseInt(e.target.value));
              }}
            >
              {Object.entries(ringDis).map(([key, value]) => (
                <option key={key} value={parseInt(key)}>
                  {value}
                </option>
              ))}
            </select>
            {errors?.routing?.ring_dist && (
              <p className="text-danger">{errors.routing.ring_dist.message}</p>
            )}
          </div>
        </div>
        {/* <div className="add-numbermain align-items-start">
          <div className="tel-numbers">
            {t("external_Numbers")}
            <br />
          </div>
          <div>
            <div className="d-flex justify-content-end">
              <div className="phoneselect">
                <div className="phoneselect">
                  <label className="switch">
                    <input className="form-control" type="checkbox" />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {displayOver && (
          <div className="add-numbermain">
            <>
              <div className="tel-numbers">{t("ringTime")}</div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <input
                    type="text"
                    className="form-control w-100"

                    {...register("routing.overall_ring_time", {
                      required: "Over All Ring Time should not be empty",
                      setValueAs: (value) => (value === "" ? "" : Number(value)),
                      onChange:(e) => {
                      clearErrors("routing.overall_ring_time");
                      setValue(
                        "routing.overall_ring_time",
                        e.target.value.trim() !== ""
                          ? parseInt(e.target.value)
                          : "",
                        { shouldDirty: true }
                      );
                    }
                    })}
                    value={watch("routing.overall_ring_time")}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                        event.stopPropagation();
                      }
                    }}
                  />
                  <span className="seconds">{t("seconds")}</span>
                  {errors?.routing?.overall_ring_time && (
                    <p className="text-danger text-start">
                      {errors.routing.overall_ring_time.message}
                    </p>
                  )}
                </div>
              </div>
            </>
          </div>
        )}
        {displaySeq && (
          <div className="add-numbermain">
            <>
              <div className="tel-numbers">
                {t("Sequence_Ringtime")}
                {/* <br />
                <span className="phrecording text-secondary">
                  {t("Sequence_Ringtime_txt")}
                </span> */}
              </div>
              <div className="w-30">
                <div className="d-flex">
                  <div className="phoneselect w-100">
                    <input
                      type="text"
                      {...register("routing.per_seq_ring_time", {
                        required: "Per Sequence Ring Time should not be empty",
                        setValueAs: (value) => (value === "" ? "" : Number(value)),
                        onChange:(e) => {
                        clearErrors("routing.per_seq_ring_time");
                        setValue(
                          "routing.per_seq_ring_time",
                          e.target.value.trim() !== ""
                            ? parseInt(e.target.value)
                            : "",
                          { shouldDirty: true }
                        );
                      }
                      })}
                      value={watch("routing.per_seq_ring_time")}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      className="selectname w-100"
                    />
                    <span className="seconds">{t("seconds")}</span>
                  </div>
                </div>
                {errors?.routing?.per_seq_ring_time && (
                  <p className="text-danger text-start">
                    {errors.routing.per_seq_ring_time.message}
                  </p>
                )}
              </div>
            </>
          </div>
        )}

        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("Busy")} <br />
            <span className="phrecording text-secondary">
              {assocCallFlows && assocCallFlows?.length > 0
                ? t("routeCalls_flows")
                : t("routeCalls_flows_default")}
            </span>
          </div>
          <div className="w-30 sm-w-40">
            {/*
              ── OLD BusyNoAnswerRoute (kept, commented out) ──
              <BusyNoAnswerRoute
                operatorsList={destRecords}
                operatorValue={routDetails}
                CallerList={callerList}
                executeSetting={executeSetting}
                setIsloading={setIsloading}
                assocCallFlows={assocCallFlows}
              />
            */}

            {/* ── NEW unified RouteCalls ── */}
            <div
              {...(assocCallFlows?.length > 0
                ? {
                    title:
                      "Not allowed to edit as group associated with Call Flows :" +
                      assocCallFlows?.map((ele) => ele.name)?.toString(),
                    className: "disabled-form cursor-notAllowed",
                    onClick: (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    },
                  }
                : {})}
            >
              <RouteCalls
                destRecords={destRecords}
                callerList={callerList}
                command={-1}
                fieldNames={hgBusyFieldNames}
                routeDetails={routDetails}
                executeSetting={executeSetting}
                setIsloading={setIsloading}
                mainLabel="Search and Select If Busy or No Answer Route"
                mainRouteError="Please Select If Busy or No Answer Route"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HGRoutings;
